import { cn } from '@discover-lib/utils';
import React, { ComponentPropsWithoutRef } from 'react';

type BookingWidgetWrapperProps = ComponentPropsWithoutRef<'div'>;

const BookingWidgetWrapper = ({ children, className, ...props }: BookingWidgetWrapperProps) => (
  <div {...props} className={cn('overflow-hidden md:p-8', className)}>
    {children}
  </div>
);

export default BookingWidgetWrapper;
